import React, { useEffect } from 'react'
import { Views } from '../../views'
import { connect } from 'react-redux'
import { routersHelper } from '../../helpers'

const Rejoin = ({ keycloak, language }) => {
    const { useRouter } = routersHelper
    const router = useRouter()
    const { query: { room, pause },location: {hash} } = router

    useEffect(() => {
        if (String(window._env_.noIDP).toLowerCase() === "true") {
            if (pause) {
                console.log(`noIDP ${window._env_.vRoomUrl}/${room}?isTokenFail=true${hash}`)
            } else {
                console.log('noIDP')
                document.body.style.setProperty("background-color", "#1b2738", "important")
                window.location.href = `${window._env_.vRoomUrl}/${room}?isTokenFail=true${hash}`
            }
        }
    })

    const { Rejoin } = Views
    return (
        String(window._env_.noIDP).toLowerCase() !== "true" ? <Rejoin keycloak={keycloak} language={language} hash={hash} /> : null
    )
}

const mapStateToProps = state => ({
    keycloak: state.keycloak,
    language: state.language
})

export default connect(mapStateToProps)(Rejoin)
